import { jsx as _jsx } from "react/jsx-runtime";
import { classes } from "./classes.js";
/**
 * Broadsheet's `.tag` variants, plus the status *roles* the product needs.
 *
 * The design shows Billing healthy / low / declined / out-of-credit and Channel
 * connected / coming-soon / not-connected. Broadsheet has two accents and no status
 * vocabulary, so the roles are named here and resolved to ramp steps by
 * `wetalk-tokens.css` — never to a new colour ("Do not use both accents in the same
 * small component" is why a call site cannot pick the accent directly).
 */
export const TAG_TONES = ["accent", "accent-2", "neutral", "outline"];
export const TAG_STATUSES = ["positive", "caution", "critical", "muted"];
export function Tag({ tone = "neutral", status, children }) {
    return (_jsx("span", { className: classes("tag", `tag-${tone}`, status !== undefined && `wt-tag-${status}`), children: children }));
}
//# sourceMappingURL=tag.js.map